import { useReveal } from "@/hooks/useReveal";

const CERT_PDF_URL = "#";
const SPEC_PDF_URL = "#";

const BADGES = [
  {
    name: "Ecocert — USDA Organic",
    desc: "Certified against the USDA National Organic Programme.",
  },
  {
    name: "Ecocert — EU Organic (EOS)",
    desc: "Certified against the EU organic regulation.",
  },
  {
    name: "HACCP",
    desc: "Hazard analysis and critical control points.",
  },
  {
    name: "INVIMA (Colombian food authority)",
    desc: "Registered with the Colombian food safety authority.",
  },
];

const SPECS = [
  {
    name: "Technical data sheet — cane sugar",
    url: "https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/d15fc6d0-83ac-41db-b55c-8f4e17db0eac_tecnical_data_sheet_panela_cane_sugar_mesa_baja.pdf",
  },
  {
    name: "Technical data sheet — cocoa powder",
    url: "https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/a870e33d-bc4e-477a-980c-998817ab596b_tecnical_data_sheet_cocoa_powder_mesa_baja.pdf",
  },
];

export default function Certifications() {
  const headingRef = useReveal<HTMLDivElement>();
  const badgesRef = useReveal<HTMLDivElement>();
  const specsRef = useReveal<HTMLDivElement>();

  return (
    <section id="certifications" className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={headingRef} className="reveal text-center">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            Certifications and documents
          </h2>
          <p className="mt-4 text-ink/70 text-lg">
            Available on request. Write to us and we will send them directly.
          </p>
        </div>

        <div ref={badgesRef} className="reveal mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {BADGES.map((badge) => (
            <div
              key={badge.name}
              className="flex flex-col rounded-lg border border-cream-dark/70 bg-cream/40 p-6"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-md bg-brand/10">
                <i className="ri-award-line text-brand text-xl"></i>
              </div>
              <h3 className="mt-4 text-ink font-serif text-lg font-semibold leading-snug">
                {badge.name}
              </h3>
              <p className="mt-2 text-ink/60 text-sm leading-relaxed flex-1">
                {badge.desc}
              </p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-brand text-sm font-semibold">
                Available on request
              </span>
            </div>
          ))}
        </div>

        <div ref={specsRef} className="reveal mt-8 flex flex-col sm:flex-row flex-wrap gap-3 justify-center">
          {SPECS.map((spec) => (
            <a
              key={spec.name}
              href={spec.url}
              target="_blank"
              rel="noopener noreferrer"
              download
              className="inline-flex items-center gap-2 whitespace-nowrap px-5 py-3 rounded-md border-2 border-brown text-brown text-base font-semibold transition-colors hover:bg-brown hover:text-white cursor-pointer"
            >
              <i className="ri-download-2-line text-lg"></i>
              {spec.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}